import {
  ControlProps,
  isDateControl,
  RankedTester,
  rankWith
} from '@jsonforms/core'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { useRef } from 'react'
import DatePicker from 'react-datepicker'
import './styles.scss'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const DatePickerControl = (props: ControlProps) => {
  const { label, path, handleChange, data, schema, errors, enabled } = props
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dateFormat = (schema as any).isCustomMonth ? 'MM/yyyy' : 'MM/dd/yyyy'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const showMonthYearPicker = (schema as any).isCustomMonth
  const placeholderText = showMonthYearPicker ? 'MM/YYYY' : 'MM/DD/YYYY'

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const datepickerRef = useRef<any>(null) // OR React.createRef();  if you are not using hooks

  // OPENS UP THE DATEPICKER WHEN THE CALENDAR ICON IS CLICKED FOR THE INPUT FIELD
  function handleClickDatepickerIcon() {
    const datepickerElement = datepickerRef?.current
    if (datepickerElement) {
      datepickerElement?.setFocus(true)
    }
  }

  const getDate = () => {
    return data ? new Date(data) : undefined
  }

  return (
    <>
      <div className='form-group'>
        <label className='custom-date-label'>{label}</label>
        <DatePicker
          selected={getDate()}
          dateFormat={dateFormat}
          showMonthYearPicker={showMonthYearPicker}
          showMonthDropdown
          showYearDropdown
          disabledKeyboardNavigation
          dropdownMode='select'
          onChange={(date: Date) => {
            if (date) {
              return handleChange(path, date.toLocaleDateString('en-US'))
            } else {
              return handleChange(path, '')
            }
          }}
          popperProps={{ strategy: 'fixed' }}
          className='form-control'
          placeholderText={placeholderText}
          ref={datepickerRef} // attach the ref
          disabled={!enabled}
          data-testid='custom-datepicker'
        ></DatePicker>
        <span
          className='mdi mdi-calendar float-right'
          onClick={() => handleClickDatepickerIcon()}
          style={{ opacity: !enabled ? '0.5' : '1' }}
        ></span>
        <div className='text-danger'>
          {errors && errors === 'is a required property' && (
            <span>{label} is required</span>
          )}
        </div>
      </div>
    </>
  )
}

export const datePickerControlTester: RankedTester = rankWith(5, isDateControl)

export default withJsonFormsControlProps(DatePickerControl)
